<template>
  <div>
    <h3 style="text-align: left">Doctor Detail</h3>
    <md-toolbar class="md-transparent">
      <md-button @click="backToList">Back to List</md-button>
      <md-button @click="deleteDoctor">Delete</md-button>
      <md-button v-show="doctor.DoctorStatus != 'Active'" @click="activateDoctor">Activate</md-button>
      <md-button v-show="!edit" @click="editDoctor">Edit</md-button>
      <md-button v-show="edit" @click="saveEdit">Save</md-button>
      <md-button v-show="edit" @click="cancelEdit">Cancel</md-button>
    </md-toolbar>
    <!--Main container-->
    <div class="init-wrapper init-fixed-sidebar">
      <div id="gcApp" class="main-content">
        <div v-if="edit" class="personal-info-wrapper">
          <!--Doctor Personal Info-->
          <div class="md-layout md-alignment-center-center">
            <div class="md-layout-item">
              <!--Doctor Photograph-->
              <div class="panel panel-default panel-border-color panel-border-color-primary">
                <div class="panel-body">
                  <div v-if="doctor.ProfileImage" align="Center">
                    <!-- <img :src="`https://gcdevstor.blob.core.windows.net/gcdev-drphoto/${doctor.ProfileImage}`" class="drimg"> -->
                    <img :src="`${process.env.VUE_APP_DOCTOR_PHOTOS}${doctor.ProfileImage}`" class="drimg" />
                    <div class="flex-box">
                      <md-button class="md-transparent md-round md-fileinput image-wrapper">
                        <template>Select image</template>
                        <input id="ProfileImage" type="file" name="ProfileImage" @change="uploadPicture" />
                      </md-button>
                    </div>
                  </div>

                  <div v-else align="Center">
                    <a href="https://placeholder.com"><img src="https://via.placeholder.com/150" /></a>
                    <div>
                      <div class="flex-box">
                        <md-button class="md-transparent md-round md-fileinput image-wrapper">
                          <template>Select image</template>
                          <input id="ProfileImage" type="file" name="ProfileImage" @change="uploadPicture" />
                        </md-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="md-layout md-alignment-center-center">
            <div class="md-layout-item provider-title">
              <h3 class="provider-title">Personal Information</h3>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <div class="md-card md-theme-default">
                <div class="md-card-content">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-33">
                      <md-field :class="[{ 'md-error': errors.has('FirstName') }]">
                        <label class="info-header">First Name</label>
                        <md-input
                          v-validate="modelValidations.FirstName"
                          v-model="doctor.FirstName"
                          name="FirstName"
                          type="text"
                        />
                        <!-- <slide-y-down-transition> -->
                        <md-icon v-show="errors.has('FirstName')" class="error">close</md-icon>
                        <!-- </slide-y-down-transition> -->
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-33">
                      <md-field :class="{ 'md-error': errors.has('LastName') }">
                        <label class="info-header">Last Name</label>
                        <md-input v-validate="'required'" v-model="doctor.LastName" name="LastName" type="text" />
                        <md-icon v-show="errors.has('LastName')" class="error">close</md-icon>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-33">
                      <md-field>
                        <label class="info-header">Title</label>
                        <md-input v-model="doctor.Title" type="text" />
                      </md-field>
                    </div>
                  </div>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-33">
                      <md-field :class="{ 'md-error': errors.has('Email') }">
                        <label class="info-header">Email</label>
                        <md-input v-validate="modelValidations.Email" v-model="doctor.Email" name="Email" type="text" />
                        <md-icon v-show="errors.has('Email')" class="error">close</md-icon>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-33">
                      <md-field>
                        <label class="info-header">Cell Number</label>
                        <md-input v-model="doctor.CellNumber" type="text" />
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-33">
                      <label class="shift-label-right">Allow SMS </label>
                      <md-radio v-model="doctor.AllowSMS" :value="true">Yes</md-radio>
                      <md-radio v-model="doctor.AllowSMS" :value="false">No</md-radio>

                      <!--
                            <md-field>
                              <label class="info-header">Allow SMS</label>
                              <md-input v-model="doctor.AllowSMS" type="text" />
                            </md-field>
                            -->
                    </div>
                  </div>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-33">
                      <md-field>
                        <label class="info-header">GlobeChek Status</label>
                        <md-select v-model="doctor.DoctorStatus" name="status">
                          <md-option value="Active">Active</md-option>
                          <md-option value="Pending">Pending</md-option>
                        </md-select>
                        <!-- <md-input v-model="doctor.DoctorStatus" type="text" /> -->
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-33">
                      <md-field>
                        <label class="info-header">File Date</label>
                        <md-input v-model="doctor.created_at" type="text" />
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-33" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="personal-info-wrapper">
          <!--Doctor Personal Info-->
          <div class="md-layout md-alignment-center-center">
            <div class="md-layout-item">
              <!--Doctor Photograph-->
              <div class="panel panel-default panel-border-color panel-border-color-primary">
                <div class="panel-body">
                  <div v-if="doctor.ProfileImage" align="Center">
                    <!-- <img :src="`https://gcdevstor.blob.core.windows.net/gcdev-drphoto/${doctor.ProfileImage}`" class="drimg"> -->
                    <img :src="`${process.env.VUE_APP_DOCTOR_PHOTOS}${doctor.ProfileImage}`" class="drimg" />
                  </div>
                  <div v-else align="Center">
                    <a href="https://placeholder.com"><img src="https://via.placeholder.com/150" /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="md-layout md-alignment-center-center">
            <div class="md-layout-item provider-title">
              <h3 class="provider-title">Personal Information</h3>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <div class="md-card md-theme-default">
                <div class="md-card-content">
                  <div class="md-layout">
                    <div class="md-layout-item">
                      <span class="info-header">First Name: </span>{{ doctor.FirstName }}
                    </div>
                    <div class="md-layout-item"><span class="info-header">Last Name: </span>{{ doctor.LastName }}</div>
                    <div class="md-layout-item"><span class="info-header">Title: </span>{{ doctor.Title }}</div>
                  </div>

                  <div class="md-layout">
                    <div class="md-layout-item"><span class="info-header">Email: </span>{{ doctor.Email }}</div>
                    <div class="md-layout-item">
                      <span class="info-header">Cell Number: </span>{{ doctor.CellNumber }}
                    </div>
                    <div class="md-layout-item">
                      <span class="info-header">Allow SMS: </span>{{ doctor.AllowSMS ? "Yes" : "No" }}
                    </div>
                  </div>
                  <div class="md-layout">
                    <div class="md-layout-item">
                      <span class="info-header">GlobeChek Status: </span>{{ doctor.DoctorStatus }}
                    </div>
                    <div class="md-layout-item">
                      <span class="info-header">File Date: </span>{{ doctor.created_at }}
                    </div>
                    <div class="md-layout-item" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!edit">
          <div class="md-layout md-alignment-center-center">
            <div class="md-layout-item provider-title">
              <h3 class="provider-title">Provider Information</h3>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <div class="md-card md-theme-default">
                <div class="md-card-content">
                  <div class="md-layout">
                    <div class="md-layout-item">
                      <span class="info-header">Qualification: </span>:{{ doctor.Qualification }}
                    </div>
                    <div class="md-layout-item">
                      <span class="info-header">Specialization: </span>{{ doctor.Specialization }}
                    </div>
                    <div class="md-layout-item">
                      <span class="info-header">Sub-Specialization: </span>{{ doctor.SubSpecialization }}
                    </div>
                  </div>

                  <div class="md-layout">
                    <div class="md-layout-item">
                      <span class="info-header">Specialities: </span>{{ doctor.Specialities }}
                    </div>
                    <div class="md-layout-item">
                      <span class="info-header">Board Certified?: </span>{{ doctor.BoardCertified ? "Yes" : "No" }}
                    </div>
                    <div class="md-layout-item">
                      <span class="info-header">Certification Date: </span>{{ doctor.CertificationDate }}
                    </div>
                  </div>
                  <div class="md-layout">
                    <div class="md-layout-item"><span class="info-header">CAQH: </span>{{ doctor.CAQH }}</div>
                    <div class="md-layout-item"><span class="info-header">NPI: </span>{{ doctor.NPI }}</div>
                    <div class="md-layout-item"><span class="info-header">License: </span>{{ doctor.License }}</div>
                  </div>
                  <div class="md-layout">
                    <div class="md-layout-item"><span class="info-header">Languages: </span>{{ doctor.Languages }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="md-layout md-alignment-center-center">
            <div class="md-layout-item provider-title">
              <h3 class="provider-title">Practice Information</h3>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <div class="md-card md-theme-default">
                <div class="md-card-content">
                  <div class="md-layout">
                    <div class="md-layout-item"><span class="info-header">Practice: </span>{{ doctor.Practice }}</div>
                    <div class="md-layout-item"><span class="info-header">Website: </span>{{ doctor.Website }}</div>
                    <div class="md-layout-item"><span class="info-header">Phone Number: </span>{{ doctor.Phone }}</div>
                  </div>
                  <div class="md-layout">
                    <div class="md-layout-item"><span class="info-header">Address: </span>{{ doctor.Address }}</div>
                    <div class="md-layout-item"><span class="info-header">City: </span>{{ doctor.City }}</div>
                    <div class="md-layout-item"><span class="info-header">State: </span>{{ doctor.State }}</div>
                  </div>
                  <div class="md-layout">
                    <div class="md-layout-item"><span class="info-header">Zip Code: </span>{{ doctor.Zip }}</div>
                    <div class="md-layout-item"><span class="info-header">Country: </span>{{ doctor.Country }}</div>
                    <div class="md-layout-item" />
                  </div>
                  <div class="md-layout">
                    <div class="md-layout-item"><span class="info-header">Latitude: </span>{{ doctor.Latitude }}</div>
                    <div class="md-layout-item"><span class="info-header">Longitude: </span>{{ doctor.Longitude }}</div>
                    <div class="md-layout-item" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style="margin-left: 0px">
            <div align="Center">
              <iframe :src="practiceCoordinates" />
            </div>
          </div>
          <hr
            align="Left"
            style="
              border-bottom: 0.5px solid#d3dbd4;
              margin-top: 5px;
              margin-bottom: 5px;
              margin-left: 30px;
              width: 80%;
            "
          />
        </div>

        <!-- Update Forms -->
        <div v-else>
          <div class="md-layout md-alignment-center-center">
            <div class="md-layout-item provider-title">
              <h3 class="provider-title">Provider Information</h3>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <form>
                <div class="md-card md-theme-default">
                  <div class="md-card-content">
                    <div class="md-layout">
                      <div class="md-layout-item md-size-33">
                        <md-field>
                          <label class="info-header">Qualification</label>:
                          <md-input v-model="doctor.Qualification" type="text" />
                        </md-field>
                      </div>
                      <div class="md-layout-item md-size-33">
                        <md-field>
                          <label class="info-header">Specialization</label>
                          <md-input v-model="doctor.Specialization" type="text" />
                        </md-field>
                      </div>
                      <div class="md-layout-item md-size-33">
                        <md-field>
                          <label class="info-header">Sub-Specialization</label>
                          <md-input v-model="doctor.SubSpecialization" type="text" />
                        </md-field>
                      </div>
                    </div>

                    <div class="md-layout">
                      <div class="md-layout-item md-size-33">
                        <md-field>
                          <label class="info-header">Specialties</label>
                          <md-input v-model="doctor.Specialities" type="text" />
                        </md-field>
                      </div>
                      <div class="md-layout-item">
                        <label class="shift-label-right">Board Certified? </label>
                        <md-radio v-model="doctor.BoardCertified" :value="true">Yes</md-radio>
                        <md-radio v-model="doctor.BoardCertified" :value="false">No</md-radio>
                        <!--
                            <md-field>
                            <label class="info-header">Board-Certified?</label>
                            <md-input v-model="doctor.BoardCertified" type="text" />
                          </md-field>
                          -->
                      </div>
                      <div class="md-layout-item">
                        <md-field>
                          <label class="info-header">Certificate Date:</label>
                          <md-input v-model="doctor.CertificationDate" type="text" />
                        </md-field>
                      </div>
                    </div>
                    <div class="md-layout">
                      <div class="md-layout-item md-size-33">
                        <md-field>
                          <label class="info-header">CAQH</label>
                          <md-input v-model="doctor.CAQH" type="text" />
                        </md-field>
                      </div>
                      <div class="md-layout-item md-size-33">
                        <md-field>
                          <label class="info-header">NPI</label>
                          <md-input v-model="doctor.NPI" type="text" />
                        </md-field>
                      </div>
                      <div class="md-layout-item">
                        <md-field>
                          <label class="info-header">License</label>
                          <md-input v-model="doctor.License" type="text" />
                        </md-field>
                      </div>
                    </div>
                    <div class="md-layout">
                      <div class="md-layout-item md-size-33">
                        <md-field>
                          <label class="info-header">Languages</label>
                          <md-input v-model="doctor.Languages" type="text" />
                        </md-field>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="md-layout md-alignment-center-center">
            <div class="md-layout-item provider-title">
              <h3 class="provider-title">Practice Information</h3>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <div class="md-card md-theme-default">
                <div class="md-card-content">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-33">
                      <md-field>
                        <label class="info-header">Practice</label>
                        <md-input v-model="doctor.Practice" type="text" />
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-33">
                      <md-field>
                        <label class="info-header">Website</label>
                        <md-input v-model="doctor.Website" type="text" />
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-33">
                      <md-field>
                        <label class="info-header">Phone Number</label>
                        <md-input v-model="doctor.Phone" type="text" />
                      </md-field>
                    </div>
                  </div>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-33">
                      <md-field>
                        <label class="info-header">Address</label>
                        <md-input v-model="doctor.Address" type="text" />
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-33">
                      <md-field>
                        <label class="info-header">City</label>
                        <md-input v-model="doctor.City" type="text" />
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-33">
                      <md-field>
                        <label class="info-header">State</label>
                        <md-input v-model="doctor.State" type="text" />
                      </md-field>
                    </div>
                  </div>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-33">
                      <md-field>
                        <label class="info-header">Zip Code</label>
                        <md-input v-model="doctor.Zip" type="text" />
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-33">
                      <md-field>
                        <label class="info-header">Country</label>
                        <md-input v-model="doctor.Country" type="text" />
                      </md-field>
                    </div>
                    <div class="md-layout-item" />
                  </div>
                  <div class="md-layout">
                    <div class="md-layout-item">
                      <md-field>
                        <label class="info-header">Latitude</label>
                        <md-input v-model="doctor.Latitude" type="text" />
                      </md-field>
                    </div>
                    <div class="md-layout-item">
                      <md-field>
                        <label class="info-header">Longitude</label>
                        <md-input v-model="doctor.Longitude" type="text" />
                      </md-field>
                    </div>
                    <div class="md-layout-item" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style="margin-left: 0px">
            <div align="Center">
              <iframe :src="practiceCoordinates" />
            </div>
          </div>
          <hr
            align="Left"
            style="
              border-bottom: 0.5px solid#d3dbd4;
              margin-top: 5px;
              margin-bottom: 5px;
              margin-left: 30px;
              width: 80%;
            "
          />
        </div>
      </div>
    </div>
    <!--END Main Container-->
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions"
import VeeValidate from "vee-validate"

//import ... from '@/components/...'
export default {
  name: "NewComponent",
  components: {},
  data() {
    return {
      name: "Sam",
      ststus: "Ready",
      mode: "view",
      doctorCurr: 1,
      doctorID: null,
      doctor: {},
      preEditDoctor: {},
      practiceCoordinates: "https://maps.google.com/maps?q=10.305385,77.923029&hl=es;z=14&amp;output=embed",
      edit: false,
      modelValidations: {
        FirstName: {
          required: true,
          min: 2,
          alpha: true
        },
        LastName: {
          required: true,
          min: 2,
          alpha: true
        },
        Email: {
          required: true,
          email: true
        }
      },
      touched: {
        FirstName: false
      }
    }
  },
  computed: {
    currentDoctor() {
      return this.doctorCurr
    }
  },
  created: function () {
    this.doctorCurr = this.$route.params.id
    this.getDoctorDetail()
  },
  mounted: function () {},
  updated: function () {},
  destroyed: function () {},
  methods: {
    backToList() {
      this.$router.push("/portal/admin/doctors-list")
    },
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    validate() {
      return this.$validator.validateAll()
    },
    getDoctorDetail: function () {
      const url = process.env.VUE_APP_URL
      const config = {
        headers: {
          "Content-Type": "application/json"
          //'Access-Control-Allow-Origin': '*',
        }
      }
      var vm = this
      window.axios
        .get(url + "/drregistration/" + this.currentDoctor)
        .then(function (response) {
          vm.doctor = response.data[0]
          //console.log(response.data[0])
        })
        .catch(function (error) {
          vm.status = "An error occurred: " + error
          alert(vm.status + "\n" + API_SERVICE)
        })
    },
    editDoctor() {
      if (this.edit) {
        this.edit = false
      } else {
        this.edit = true
        this.preEditDoctor = JSON.parse(JSON.stringify(this.doctor))
      }
    },
    saveEdit() {
      this.validate().then((res) => {
        if (res) {
          this.updateDoctor()
        } else {
        }
      })
    },
    cancelEdit() {
      this.doctor = this.preEditDoctor
      this.edit = false
    },
    updateDoctor() {
      console.log(this.doctor)
      const url = process.env.VUE_APP_URL
      const config = {
        headers: {
          //'Content-Type': 'application/x-www-form-urlencoded',
          "Content-Type": "application/json"
          //'Access-Control-Allow-Origin': '*',
        }
      }
      var vm = this
      window.axios
        .put(url + "/doctor-registration/" + this.doctorCurr, this.doctor)
        .then(function (response) {
          vm.edit = false
          console.log(response)
        })
        .catch(function (error) {
          vm.status = "An error occurred: " + error
          alert(vm.status)
        })
    },
    deleteDoctor() {
      let confirmDelete = window.confirm("Delete this doctor?")
      if (confirmDelete) {
        console.log("Deleting doctor " + this.doctorCurr)
        const url = process.env.VUE_APP_URL
        const config = {
          headers: {
            //'Content-Type': 'application/x-www-form-urlencoded',
            "Content-Type": "application/json"
            //'Access-Control-Allow-Origin': '*',
          }
        }
        var vm = this
        window.axios
          .delete(url + "/doctor-registration/" + this.doctorCurr)
          .then(function (response) {
            console.log(response)
            vm.$router.push("/portal/admin/doctors-list")
          })
          .catch(function (error) {
            vm.status = "An error occurred: " + error
            alert(vm.status)
          })
      }
    },
    activateDoctor() {
      const url = process.env.VUE_APP_URL
      this.doctor.DoctorStatus = "Active"
      const config = {
        headers: {
          //'Content-Type': 'application/x-www-form-urlencoded',
          "Content-Type": "application/json"
          //'Access-Control-Allow-Origin': '*',
        }
      }
      var vm = this
      window.axios
        .put(url + "/doctor-registration/" + this.doctorCurr, this.doctor)
        .then(function (response) {
          vm.edit = false
          console.log(response)
        })
        .catch(function (error) {
          vm.status = "An error occurred: " + error
          alert(vm.status)
        })
    },
    uploadPicture() {
      const url = process.env.VUE_APP_URL
      console.log("url is " + url)
      const file = event.target.files[0]
      console.log(file)
      var ProfileImage = new FormData()
      var imagefile = document.querySelector("#ProfileImage")
      console.log("file captured")
      console.log(imagefile.files[0])
      ProfileImage.append("ProfileImage", imagefile.files[0])
      let vm = this
      window.axios
        .put(url + "/drimage/" + this.doctorCurr, ProfileImage, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then((r) => {
          console.log(r.data)
          vm.$router.go()
        })
    }

    /*
    goPrev(){
      if (this.doctorCurr > 1){
        this.doctorCurr--;
      }
      this.getDoctorDetail();
    },
    goNext(){
      this.doctorCurr++;
      this.getDoctorDetail();
    },
    */
  },
  watch: {
    FirstName() {
      this.touched.FirstName = true
    }
  }
}
</script>

<style>
.md-select-menu .md-list-item .md-list-item-content {
  min-height: 25px;
}
</style>

<style lang="scss" scoped>
.info-header {
  font-size: 16px;
  font-weight: 500;
}

button {
  margin-right: 15px !important;
}

.md-layout-item {
  text-align: left;
}

.image-wrapper {
  margin: 15px 0 12px;
}

.flex-box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.personal-info-wrapper {
  margin-top: 30px;
}

.provider-title {
  text-align: center;
}

.shift-label-right {
  margin-right: 5px;
}
</style>
